import type { PaymentFlowResponse } from 'commons/types/paymentTypes'

export const createWalletCheckoutOptions = (response: PaymentFlowResponse) => {
	if (
		!response.success ||
		typeof response.public_key !== 'string' ||
		!response.public_key.trim() ||
		(response.environment !== 'sandbox' && response.environment !== 'production') ||
		typeof response.payment_session_id !== 'string' ||
		!response.payment_session_id.trim() ||
		typeof response.payment_session_token !== 'string' ||
		!response.payment_session_token.trim()
	) {
		throw new Error('Invalid wallet initialization configuration')
	}
	return {
		publicKey: response.public_key,
		environment: response.environment,
		paymentSession: {
			id: response.payment_session_id,
			payment_session_token: response.payment_session_token
		}
	}
}
